import { Component, ViewChild, Output, Input, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { MenusService } from 'src/app/services/menus.service';
import { PlatformService } from 'src/app/services/platform.service';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { BuscaService } from 'src/app/services/busca.service';
import { filter, Subscription } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { NotificacoesServiceService } from '../notificacoes/notificacoes-service.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'tool-bar-actions',
    templateUrl: './tool-bar-actions.component.html',
    styleUrls: ['./tool-bar-actions.component.scss'],
    standalone: false,
})
export class ToolBarActionsComponent implements OnInit {

	@ViewChild('inputSearch') inputSearch: ElementRef;
	@ViewChild(MatMenuTrigger) private notificacoesMenuTrigger!: MatMenuTrigger;

	@Output('emitShowFilter') emitShowFilter = new EventEmitter();
	@Output('onOpenSearch') onOpenSearch = new EventEmitter();
	@Output('onCloseSearch') onCloseSearch = new EventEmitter();

	@Input('placeholder') placeholder: string = 'Nome / CPF / CNPJ / Placa';
	@Input('showIfAuthorizedName') showIfAuthorizedName: boolean = false;
	@Input('showSearch') showSearch: boolean = true;
	@Input('mostraFiltro') mostraFiltro: boolean = true;
	@Input('pagina') pagina: any = '';

	valorInput: String = '';
	verificaAlt: boolean = false;
	searchingLoad: boolean = false;
	private routeSubscription: Subscription;

	openSearch: boolean = false;
	showFilter: boolean = false;
	buscaAvancada: boolean = false;
	prefix: string = '';
	showPrefix: boolean = false;
	rota: any;
	currrentRoute: string = '';

	constructor(
		private router: Router,
		public platformService: PlatformService,
		public apiUsuario: ApiUsuarioService,
		private icons: RegisterIconsService,
		public filtroController: FiltroControllerService,
		public menuFiltro: MenusService,
		private buscaService: BuscaService,
		private notificacoesService: NotificacoesServiceService,
		protected utilsService: UtilsService
	) {
		this.icons.registerIcons(['close', 'magnify', 'loading', 'filter', 'filter-outline', 'bell'])
	}

	timeSearch

	searching(ev) {
		if (this.showFilter) {
			this.actionFilter();
		}

		if (this.showPrefix) {
			clearTimeout(this.timeSearch);
			this.timeSearch = setTimeout(() => {
				this.verificaAlt = true;
				let value = ev.target.value.toLowerCase();
				this.buscaService.enviaBusca(value);
			}, 800)
		} else {
			clearTimeout(this.timeSearch);
			this.timeSearch = setTimeout(() => {
				this.verificaAlt = true;
				let value = ev.target.value.toLowerCase();
				this.valorInput = value;

				if (this.rota == "/busca") {
					this.buscaService.enviaBusca(value);
				} else {
					this.router.navigateByUrl('/busca', { state: { valorInput: value } });
				}

			}, 800)
		}
	}

	ngOnInit() {
		this.rota = location.pathname;

		this.filtroController.verificaFiltro();

		setInterval(x => { this.filtroController.verificaFiltro(); this.verificaVariaveis() }, 1500);

		this.definePrefixo();
		this.buscaCredenciaisUsuario();

		this.buscaService.fecharBusca.subscribe(ret => { this.openSearch = ret; });

		this.routeSubscription = this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			this.ngOnDestroy(); // Manually call ngOnDestroy
		});

		this.verificaCloseNotificacoesMenu();
	}

	ngOnDestroy() {
		// Clean up subscriptions or other resources here
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	private verificaCloseNotificacoesMenu = () => {
		this.routeSubscription.add(this.notificacoesService.closeMenu$.subscribe(() => {
			this.notificacoesMenuTrigger.closeMenu();
		}))
	}

	protected showBadgeFiltro: boolean = false;
	verificaVariaveis() {
		if (this.filtroController.dashFiltroAtivo && this.rota === '/dashboard') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.dashFiltroAtivo && this.rota === '/dashboard') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.tarefasFiltroAtivo && this.rota === '/lista-tarefas') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.tarefasFiltroAtivo && this.rota === '/lista-tarefas') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.clientesFiltroAtivo && this.rota === '/clientes') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.clientesFiltroAtivo && this.rota === '/clientes') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.cotacoesFiltroAtivo && this.rota === '/cotacoes') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.cotacoesFiltroAtivo && this.rota === '/cotacoes') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.listaNegociosFiltroAtivo && this.rota === '/lista-negocios') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.listaNegociosFiltroAtivo && this.rota === '/lista-negocios') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.kanbanFiltroAtivo && this.rota === '/funil-de-vendas') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.kanbanFiltroAtivo && this.rota === '/funil-de-vendas') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.corretorasFiltroAtivo && this.rota === '/corretoras') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.corretorasFiltroAtivo && this.rota === '/corretoras') {
			this.showBadgeFiltro = false;
		}
		if (this.filtroController.temFiltroDocumentos === true && this.rota === '/documentos') {
			this.showBadgeFiltro = true;
		}
		if (!this.filtroController.temFiltroDocumentos && this.rota === '/documentos') {
			this.showBadgeFiltro = false;
		}
	}


	actionFilter() {
		this.showFilter = !this.showFilter;
		if (this.showFilter) {
			this.emitShowFilter.emit(true);
		} else {
			this.emitShowFilter.emit(false);
		}

	}

	openSearchBar() {
		this.openSearch = !this.openSearch;
		if (this.openSearch && this.showPrefix) {
			this.verificaAlt = false;
			setTimeout(() => {
				this.inputSearch.nativeElement.focus();
			}, 0);
			this.onOpenSearch.emit(this.valorInput);
		}

		else if (this.openSearch && !this.showPrefix) {
			this.verificaAlt = false;
			setTimeout(() => {
				this.inputSearch.nativeElement.focus();
			}, 0);

		}

		else {
			if (this.showPrefix) {
				this.openSearch = !this.openSearch;
				this.showPrefix = false;
				this.valorInput = '';
				if (this.verificaAlt) {
					this.buscaService.enviaBusca(this.valorInput);
				}

				this.verificaAlt = false;
				setTimeout(() => {
					this.inputSearch.nativeElement.focus();
				}, 0);

			} else {
				this.showPrefix = false;
				if (this.rota == "/clientes" || this.rota == "/cotacoes" || this.rota == "/documentos" || this.rota == "/funil-de-vendas" ||
					this.rota == "/lista-negocios" || this.rota == "/config-ramos" || this.rota == "/corretoras") {
					this.showPrefix = true;
				}
				this.valorInput = '';
				this.onCloseSearch.emit(this.valorInput);
				if (this.verificaAlt && this.rota != "/busca") {
					this.buscaService.enviaBusca(this.valorInput);
				}

			}

		}
		this.menuFiltro.enviaBuscaAberta(this.openSearch);
	}

	openFilter() {
		// Criado um desvio para utilizar o novo filtro somente na tela de Corretoras

		if (location.pathname == '/corretoras') {
			/** variavel intermediaria pra mandar o contrario sempre true e false */
			this.menuFiltro.open = !this.menuFiltro.open;
			//console.log("ToolBarActions - this.menuFiltro.setMenuFilter({open: this.menuFiltro.open, page: 'corretoras'})")
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'corretoras' })
		}
		else if (location.pathname == '/dashboard') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'dashboard' })
		}
		else if (location.pathname == '/clientes') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'clientes' })
		}
		else if (location.pathname == '/lista-tarefas') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'tarefas' })
		}
		else if (location.pathname == '/funil-de-vendas') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'negocios' })
		}
		else if (location.pathname == '/lista-negocios') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'lista-negocios' })
		}
		else if (location.pathname == '/cotacoes') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'cotacoes' })
		}
		else if (location.pathname == '/config-ramos') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'ramos' })
		}
		else if (location.pathname == '/documentos') {
			this.menuFiltro.open = !this.menuFiltro.open;
			this.menuFiltro.setMenuFilter({ open: this.menuFiltro.open, page: 'documentos' })
		}
		else {
			this.actionFilter();
		}
	}

	credenciaisUsuario: any;
	async buscaCredenciaisUsuario() {
		try {
			let ret = await this.apiUsuario.getCredenciais();
			if (ret) {
				this.credenciaisUsuario = ret
			}
		} catch (error) {
			console.log('erro ao buscar credenciais do usuario', error)
		}
	}

	definePrefixo() {
		if (this.rota == "/clientes") {
			this.prefix = "clientes";
			this.showPrefix = true;
		} else if (this.rota == "/config-ramos") {
			this.prefix = "ramos";
			this.showPrefix = true;
		} else if (this.rota == "/corretoras") {
			this.prefix = "corretoras";
			this.showPrefix = true;
		} else if (this.rota == "/cotacoes") {
			this.prefix = "cotacoes";
			this.showPrefix = true;
		} else if (this.rota == "/funil-de-vendas" || this.rota == "/lista-negocios") {
			this.prefix = "negocios";
			this.showPrefix = true;
		} else if (this.rota == "/documentos") {
			this.prefix = "documentos";
			this.showPrefix = true;

		} else if (this.rota == "/busca") {
			this.openSearch = true;
			this.showPrefix = false;
			this.prefix = "";

			if (history.state.valorInput) {
				this.valorInput = history.state.valorInput;
			}

		} else {
			this.prefix = "";
			this.showPrefix = false;
		}
	}
}
